mutation UpdateTemplate($zipUrl: String!, $masterTemplateId: ID!, $force: Boolean, $type: TemplateType) {
    updateMasterTemplate(
        temporaryBucketZipPath: $zipUrl
        masterTemplateId: $masterTemplateId
        force: $force
        type: $type
    ) {
        jobId
    }
}
